<template>
	<div class="w-100 p-3 bg-white border-15 h-center">
		<div style="width: 75%; max-width: 500px;">
			<textInput
				label = "عنوان دسته بندی"
				@inputTxtFunc = "(e)=>{val.name = e}"
				:val="val.name"
				autofocus="true"
			/>
			<textInput
				label = "title (حتما انگلیسی)"
				@inputTxtFunc = "(e)=>{val.en_title = e}"
				:val="val.en_title"
			/>
			<textInput
			label = "meta (حتما فارسی)"
			@inputTxtFunc = "(e)=>{val.meta_title = e}"
			:val="val.meta_title"
			/>
			<textareaInput
				label = "description (حتما فارسی)"
				@inputTxtFunc = "(e)=>{val.description = e}"
				:value="val.description"
			/>
			<selectInput
				@inputTxtFunc = "(e)=>{val.status = e}"
				:value = "val.status"
				label="وضعیت"
				:flds="[{'id': '1','name': 'وضعیت فعال'},{'id': '0','name': 'وضعیت غیر فعال'}]"
			/>
			<btn
				class="w-100 mt-3"
				textClass="w-100"
				text="ذخیره"
				@clickMe="sav()"
			/>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../UI/button/btn.vue";
		import switchInput from  "../../UI/input/switchInput.vue";
		import textInput from  "../../UI/input/textInput.vue";
		import datepicker from  "../../UI/input/datepicker.vue";
		import multiSelectInput from  "../../UI/input/multiSelectInput.vue";
		import selectInput from  "../../UI/input/selectInput.vue";
		import textareaInput from  "../../UI/input/textareaInput.vue";
		import userImg from  "../../UI/userImg/userImg.vue";
		import pageNavigation from  "../../UI/pageNavigation/pageNavigation.vue";
		import previewImage from  "../../UI/uploadFile/previewImage.vue";
		import { time2minutes, minutes2time, classTime, timeOptions, vlaTimeOptions } from  "../../assets/library/convertTime.js";
		import { error, success, loading } from  "../../assets/library/messege.js";
		import { is_en } from  "../../assets/library/filter.js";

		export default {
			name: 'self_part1',
			data(){
				return {
					error: error,
					success: success,
					loading: loading,
					time2minutes: time2minutes,
					minutes2time: minutes2time,
					classTime: classTime,
					timeOptions: timeOptions,
					vlaTimeOptions: vlaTimeOptions,
					is_en: is_en,
					val:{
						name: '',
						status: '0',
						meta_title: "",
						description: "",
						en_title: "",
					},
				}
			},
			components: {
				btn,
				switchInput,
				vlaTimeOptions,
				classTime,
				timeOptions,
				time2minutes,
				minutes2time,
				datepicker,
				textInput,
				selectInput,
				pageNavigation,
				userImg,
				previewImage,
				textareaInput,
				multiSelectInput,
			},
			props: {
				flds: {
					default: [],
				},
			},
			mounted(){
				(this.$route.params.id != undefined) ? this.loader() : '';
			},
			methods:{
				loader(THIS = this){
					document.body.scrollTop = 0;
					window.$.post(window.baseurl + "degrees/" + this.$route.params.id, { token: this.$localStorage.get("user") }, function(D){
						if(D.status.code=="401"){
							THIS.$localStorage.remove('user');
							THIS.$router.push('/login');
						}else{
							THIS.val = D.data;
						}
					}, "json");
				},
				//______________________________________________________________________
				sav(THIS = this){
					if(this.val.description=="" || this.val.en_title=="" || this.val.meta_title=="" || this.val.name=="" ){
						this.error(this)
					}else if(!this.is_en(this.val.en_title)){
						this.error(this, "مقدار title باید انگلیسی باشد")
					} else{
						let mod = (this.$route.params.id != undefined) ? this.$route.params.id : 'create';
						THIS.loading(THIS);
						window.$.post(window.baseurl+'degrees/' + mod, {
							role: this.$localStorage.get('user').username.role,
							name: THIS.val.name,
							meta_title:  THIS.val.meta_title,
							description:  THIS.val.description,
							en_title:  THIS.val.en_title,
							status: THIS.val.status, token: this.$localStorage.get("user"),
						}, function(D){
							if(D.ok){
								THIS.success(THIS);
								THIS.$router.push('/degrees/list');
							}else{
								THIS.error(THIS, D.message)
							}
						}, "json");
					}
				},
			}
		}
	</script>
<style>

</style>
